import { createMedia } from '@artsy/fresnel';

const DefaultAppMedia = createMedia({
  breakpoints: {
    sm: 0,
    md: 500,
    lg: 1200,
    xl: 1440,
  },
});

// Make styles for injection into the header of the page
export const mediaStyles = DefaultAppMedia.createMediaStyle();

export const { Media, MediaContextProvider } = DefaultAppMedia;
